import Swiper from 'swiper/bundle';

export function initPostsSwipers(scope = document) {
  scope.querySelectorAll('[data-posts-root]').forEach((root) => {
    const el = root.querySelector('.js-posts-swiper');
    if (!el) return;

    if (el._swiper && typeof el._swiper.destroy === 'function') {
      el._swiper.destroy(true, true);
      el._swiper = null;
    }

    let data = {};
    try { data = JSON.parse(el.getAttribute('data-options') || '{}'); } catch (_) {}

    const next = root.querySelector('.posts-next');
    const prev = root.querySelector('.posts-prev');
    const pag  = root.querySelector('.posts-pagination');

    const opts = {
      ...data,
      pagination: pag ? { el: pag, clickable: true } : undefined,
      navigation: (next && prev) ? { nextEl: next, prevEl: prev } : undefined
    };

    el._swiper = new Swiper(el, opts);

    const toggleNav = () => {
      if (!next || !prev) return;
      const bp = el._swiper.currentBreakpoint;
      const spv =
        (bp && el._swiper.params.breakpoints?.[bp]?.slidesPerView) ??
        el._swiper.params.slidesPerView ?? 1;
      const total = el._swiper.slides.length;
      const visible = typeof spv === 'number' ? spv : 1;
      const show = total > visible;
      next.style.display = show ? '' : 'none';
      prev.style.display = show ? '' : 'none';
    };

    el._swiper.on('afterInit resize breakpoint slidesLengthChange', toggleNav);
    toggleNav();
  });
}
